import React from "react"

export default React.createContext({
  menuFixed: [],
  menuOptions: [],
  addMenuOption: () => null,
  updateMenu: () => null,
})
